import PrimaryCell from "../../../../../ui/Table/Cells/PrimaryCell";
import ProgramNameCell from "./ProgramNameCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 50
  },
  {
    dataField: "name",
    caption: "Программа",
    dataType: "string",
    cellRender: ProgramNameCell
  },
  {
    dataField: "organization",
    caption: "Подрядчик",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "planStateName",
    caption: "Статус",
    dataType: "string",
    cellRender: PrimaryCell
  }
]
